
import { config } from 'util/config';
import { httpClient, psmaClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { message } from 'antd';
import CustomBadge from 'components/CustomBadge';

//显示label选择的弹出框
export function showLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageLabelShow: true });
  sectionComponent.child.current?.labelDiv.current?.getLabelList(parameter.key);
}

//各种过滤器刷新Job列表
export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  let searchParameter = { ...sectionComponent.state.searchParameter };
  if (uie !== undefined) {
    componentDefaultValue[uie.source] = parameter;
    searchParameter[uie.source] = parameter;
    sectionComponent.setState({ searchParameter, componentDefaultValue });
  }

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined) {
      filterLoaded = false;
    }
  })

  if (filterLoaded && !sectionComponent.state.firstRefresh) {
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
  sectionComponent.setState({ firstRefresh: false });
}

//显示label过滤器的弹出框
export function showFilterByLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .get('/Admin/Label/GetGroupList?module=' + pageComponent.state.searchParameter.module)
    .then(({ data }) => {
      if (data.result) {
        let labelGroup = [];
        data.data.map((item, i) => {
          let labels = [];
          item.DataList.map((label, i) => {
            labels.push({
              label: <CustomBadge text={label.Name} backgroundColor={label.BackgroundColor} verticalAlign="top" />,
              value: label.LabelId
            })
          })
          labelGroup.push({ Name: item.Name, DataList: labels });
        })
        pageComponent.setState({ labelGroup: labelGroup, filterByLabeShow: true });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, that.props.pageComponent);
    });
}

//Job列表下载Excel
export function exportToExcel({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.module = pageComponent.state.searchParameter.module;
  console.log(searchParameter);
}

//Job列表刷新
export function refreshJobPaging({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.module = pageComponent.state.searchParameter.module;
  sectionComponent.setState({ searchParameter });
  sectionComponent.getSectionDataByDefault();

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = true;
    sectionComponent.setState(sectionComponent.state.section);
  }, 100);

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = false;
    sectionComponent.setState(sectionComponent.state.section);
  }, 1100);
}

//new job时选择地址
export function searchAddressChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setAutoCompleteData(parameter);
}

export function getAddressData({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAddressData(parameter);
}

export function getLgaDataSource({ parameter, sectionComponent, pageComponent, lgaKeyName } = {}) {
  if (globalFunction.isNullOrEmpty(parameter)) {
    parameter = pageComponent.state.jobData.PptState;
  }
  httpClient
    .get('Admin/Lga/GetSelectOptionList?state=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let componentDataSource = sectionComponent.state.componentDataSource;
          componentDataSource.LgaId = data.data;
          sectionComponent.setState({ componentDataSource });
          if (data.data.map(item => { return item.Value }).indexOf(pageComponent.formRef.current?.getFieldValue('LgaId')) < 0) {
            pageComponent.formRef.current?.setFieldsValue({ LgaId: 0 });
          } else if (lgaKeyName !== null && lgaKeyName !== undefined) {
            let lag = data.data.find(item => item.Data === lgaKeyName);
            if (lag) {
              pageComponent.formRef.current?.setFieldsValue({ LgaId: lag.Value });
            } else {
              pageComponent.formRef.current?.setFieldsValue({ LgaId: 0 });
            }
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function clientJobTemplateChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ clientJobTemplateID: parameter });
}

export function loadClientJobTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (pageComponent.state.clientJobTemplateID !== undefined && pageComponent.state.clientJobTemplateID !== null && pageComponent.state.clientJobTemplateID !== 0) {
    let form = {};
    form.ClientJobTemplateID = pageComponent.state.clientJobTemplateID;
    form.jobId = pageComponent.props.jobId;
    httpClient
      .post('Business/Job/LoadClientJobTemplate', form)
      .then(({ data }) => {
        if (data.result) {
          pageComponent.formRef.current?.setFieldValue('WorkDescription', data.data.WorkDescription);
          pageComponent.formRef.current?.setFieldValue('AllotmentArea', data.data.AllotmentArea);
          pageComponent.formRef.current?.setFieldValue('TotalFloorAreaNewBuildingWork', data.data.TotalFloorAreaNewBuildingWork);
          pageComponent.formRef.current?.setFieldValue('ExternalWallMaterialId', data.data.ExternalWallMaterialId);
          pageComponent.formRef.current?.setFieldValue('ExternalWallMaterialIds', data.data.ExternalWallMaterialIds);
          pageComponent.formRef.current?.setFieldValue('FloorMaterialId', data.data.FloorMaterialId);
          pageComponent.formRef.current?.setFieldValue('FloorMaterialIds', data.data.FloorMaterialIds);
          pageComponent.formRef.current?.setFieldValue('FrameMaterialId', data.data.FrameMaterialId);
          pageComponent.formRef.current?.setFieldValue('FrameMaterialIds', data.data.FrameMaterialIds);
          pageComponent.formRef.current?.setFieldValue('RoofCladdingMaterialId', data.data.RoofCladdingMaterialId);
          pageComponent.formRef.current?.setFieldValue('RoofCladdingMaterialIds', data.data.RoofCladdingMaterialIds);
          globalFunction.getSectionComponent(pageComponent, 'JobContact')?.getSectionDataByDefault();
          globalFunction.getSectionComponent(pageComponent, 'Owner')?.getSectionDataByDefault();
          globalFunction.getSectionComponent(pageComponent, 'JobNccClass')?.getSectionDataByDefault();
          globalFunction.getSectionComponent(pageComponent, 'JobChecklist')?.getSectionDataByDefault();
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Suburb 选择后快速填写数据
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  pageComponent.formRef.current?.setFieldsValue({ PptSuburb: data.data.Name, PptPostcode: data.data.Postcode });
  if (data.data.LgaId !== null) {
    pageComponent.formRef.current?.setFieldsValue({ LgaId: data.data.LgaId });
  }
}

//显示WorkflowStatus过滤器的弹出框
export function showFilterByWorkflowStatusDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ filterByWorkflowStatusShow: true });
}
